import { Injectable } from '@angular/core';
import { ITEMTYPE, ROWPOSITION } from 'src/app/shared/components/field-item/field-item.model';

@Injectable({
   providedIn: 'root'
})

export class FieldItemRowService {

  constructor () {}

   public isRowOrColumn (fieldType: string, isRowOrCoulmn?: ROWPOSITION): string {
      if (isRowOrCoulmn) return isRowOrCoulmn;
      else {
         switch (fieldType) {
            case ITEMTYPE.text: return ROWPOSITION.column 
            case ITEMTYPE.legend: return ROWPOSITION.column 
            case ITEMTYPE.titleOne: return ROWPOSITION.column 
            case ITEMTYPE.divider: return ROWPOSITION.column; 
            case ITEMTYPE.titleSecond: return ROWPOSITION.column;
            case ITEMTYPE.radio: return ROWPOSITION.column;
            case ITEMTYPE.checkbox: return ROWPOSITION.column;
            case ITEMTYPE.rating: return ROWPOSITION.column;
            case ITEMTYPE.imgText: return ROWPOSITION.column;
            default: return ROWPOSITION.row;
         }  
      }
   }
}
